/**
 * @see https://shopify.dev/docs/api/ajax/section-rendering
 * Warning: When using the Section Rendering API, the JS in the section file will not be executed.
 * Therefore, the stepper is empty
 * It needs to be refactored
 */
async function ca_updateCartSummary() {
  const summaryEl = document.querySelector('#ca-cart-summary');

  if (!summaryEl) {
    return;
  }

  // TODO: Add a loading state
  return fetch(window.location.pathname)
    .then((res) => res.text())
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newSummary = doc.querySelector('#ca-cart-summary');
      if (newSummary) {
        summaryEl.innerHTML = newSummary.innerHTML;
      }
    });
}
